import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppPrimengModule } from '../app-primeng.module';
import { ReactiveFormsModule } from '@angular/forms';
import { TagInputModule } from 'ngx-chips';
import { SharedModule } from '../shared/shared.module';
import { MomentModule } from 'ngx-moment';
import { CadastroUsuarioGovernoPageComponent } from './components/cadastro-usuario-governo-page/cadastro-usuario-governo-page.component';
import { CadastroUsuarioGovernoListaComponent } from './components/cadastro-usuario-governo-lista/cadastro-usuario-governo-lista.component';
import { CadastroUsuarioGovernoService } from './services/cadastro-usuario-governo.service';
import { CadastroUsuarioGovernoEditPageComponent } from './components/cadastro-usuario-governo-edit-page/cadastro-usuario-governo-edit-page.component';
import { CadastroUsuarioGovernoRoutingModule } from './cadastro-usuario-governo-routing.module';


@NgModule({
  imports: [
    CommonModule,
    AppPrimengModule,
    ReactiveFormsModule,
    CadastroUsuarioGovernoRoutingModule,
    TagInputModule,
    SharedModule,
    MomentModule
  ],
  declarations: [
    CadastroUsuarioGovernoPageComponent,
    CadastroUsuarioGovernoListaComponent,
    CadastroUsuarioGovernoEditPageComponent,
  ],
  providers: [
    CadastroUsuarioGovernoService,
  ],
  exports: [
  ],
})
export class CadastroUsuarioGovernoModule { }
